<script>
  import pessoaServico from '~modulos/pessoa/servico';
  import DadosFaturamento from './compartilhado/FormDadosFaturamento.vue';
  import DadosCobranca from './compartilhado/FormDadosCobranca.vue';
  import DadosFatura from './compartilhado/FormDadosFatura.vue';
  import solicitacaoFaturamentoServico from '../servico';
  import radio from '~componentes/Radio.vue';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';
  import ListaDeArquivos from '~componentes/ListaDeArquivos.vue';
  
  export default {
    components: { DadosFaturamento, DadosCobranca, DadosFatura, radio, AdicionarArquivos, ListaDeArquivos },
    data() {
      return {
        documento: '',
        mostrarFormulario: false,
        solicitacao: this.camposSolicitacao(),
        carregando: false,
        dadosBancarios: [],
        arquivos: [],
        configuracao: this.$storage.configuracao(),
        desabilitarBeneficiario: false,
      }
    },
    mounted() {
      this.$root.tituloDaPagina = `Solicitação de Faturamento de Estrangeiro PJ - ${this.$route.params.id ? 'Editar #' + this.$route.params.id : 'Nova'}`;
      this.$root.botaoAcaoTexto = 'Nova';
      this.$root.botaoAcaoIcon = 'fa-plus';
      this.$root.botaoAcaoLink = 'solicitacao-faturamento-estrangeiro-pj.nova';
    },
    methods: {
      buscaDesabilitarBeneficiario() {
        if (this.configuracao.permissaoAlteracaoNomeBeneficiario != 0)
          return false;

        if (!this.solicitacao.documento)
          return false;

        return pessoaServico
          .buscaestrangeiro(this.solicitacao.documento)
          .then(pessoa => {
            if (pessoa.nomePessoaFisicaJuridica)
              this.desabilitarBeneficiario = true;
          })
          .catch(error => {
            });
      },
      buscarBeneficiario() {
        $('#avancar').button('loading');
        
        return pessoaServico
          .buscaestrangeiro(this.documento)
          .then(pessoa => {
            $('#avancar').button('reset');

            this.solicitacao.nome = pessoa.nomePessoaFisicaJuridica.substring(0, 100);
            this.solicitacao.enderecoFaturamento = pessoa.endereco.substring(0, 100);
            this.solicitacao.numeroFaturamento = pessoa.numero.substring(0, 10);
            this.solicitacao.complementoFaturamento = pessoa.complemento.substring(0, 30);
            this.solicitacao.bairroFaturamento = pessoa.bairro.substring(0, 60);
            this.solicitacao.cidadeFaturamento = pessoa.cidade.substring(0, 60);
            this.solicitacao.ufFaturamento = pessoa.estado.substring(0, 2);
            this.solicitacao.cepFaturamento = pessoa.cep.substring(0, 9);
            this.solicitacao.telefoneFaturamento = pessoa.telefone1.substring(0, 20);
            this.solicitacao.faxFaturamento = pessoa.fax.substring(0, 20);
            this.solicitacao.contatoFaturamento = pessoa.email.substring(0, 300);
            this.solicitacao.pais = pessoa.pais.substring(0, 30);
            this.solicitacao.paisCobranca = pessoa.pais.substring(0, 30);
            this.solicitacao.documento = this.documento;
            
            if (pessoa.enderecoCobranca) {
              this.solicitacao.enderecoCobranca = pessoa.enderecoCobranca.substring(0, 200);
              this.solicitacao.numeroCobranca = pessoa.numeroCobranca.substring(0, 10);
              this.solicitacao.complementoCobranca = pessoa.complementoCobranca.substring(0, 30);
              this.solicitacao.bairroCobranca = pessoa.bairroCobranca.substring(0, 60);
              this.solicitacao.cidadeCobranca = pessoa.cidadeCobranca.substring(0, 60);
              this.solicitacao.ufCobranca = pessoa.estadoCobranca.substring(0, 2);
              this.solicitacao.cepCobranca = pessoa.cepCobranca.substring(0, 9);
            } else {
              this.solicitacao.enderecoCobranca = pessoa.endereco.substring(0, 200);
              this.solicitacao.numeroCobranca = pessoa.numero.substring(0, 10);
              this.solicitacao.complementoCobranca = pessoa.complemento.substring(0, 30);
              this.solicitacao.bairroCobranca = pessoa.bairro.substring(0, 60);
              this.solicitacao.cidadeCobranca = pessoa.cidade.substring(0, 60);
              this.solicitacao.ufCobranca = pessoa.estado.substring(0, 2);
              this.solicitacao.cepCobranca = pessoa.cep.substring(0, 9);
            }
            
            this.$set(this, 'mostrarFormulario', true);
            this.mostrarInstrucoes();
            this.buscaDesabilitarBeneficiario();
          })
          .catch(error => {
            $('#avancar').button('reset');
			
            this.solicitacao.documento = this.documento;
            
			      this.$set(this, 'mostrarFormulario', true);
            this.mostrarInstrucoes();
          });
      },
      validarBeneficiario() {
        this.$validator
          .validate('documento', this.documento)
          .then(valido => {
            if (!valido) throw new Error("validacao");
          })
          .then(this.buscarBeneficiario)
          .catch(erro => {
            this.$mensagemErro(erro);
          });
      },
      mostrarInstrucoes() {
        if (!this.configuracao.instrucoesSolFaturamentoEstrangeiroPJ || this.$route.params.id) return;

        this.$swal({
          title: 'Instruções da solicitação',
          html: this.configuracao.instrucoesSolFaturamentoEstrangeiroPJ.replace(/\r\n/g, '<br>'),
          type: 'info',
          confirmButtonText: 'Ok, entendi!',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      },
      salvar() {
        $('#salvar').button('loading');
        
        this.$refs.dadosFaturamento
          .validar()
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-faturamento"]').tab('show');
            }

            return valido;
          })
          .then(this.$refs.dadosCobranca.validar)
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-cobranca"]').tab('show');
            }

            return valido;
          })
          .then(this.$refs.dadosFatura.validar)
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-fatura"]').tab('show');
            }

            return valido;
          })
          .then(this.validarSePossuiItens)
          .then(this.enviar)
          .then(id => {
            this.$imprimirRelatorio('solicitacao-faturamento-estrangeiro-pj.relatorio', id, 'solicitacao-faturamento-estrangeiro-pj');
          })
          .catch(erro => {
            $('#salvar').button('reset');
            this.$mensagemErro(erro, 'Erro ao salvar a solicitação.');
          });
      },
      validarSePossuiItens(valido) {
        if (this.configuracao.abreviaturaFundacao.toUpperCase() !== 'FUSP') return valido;
        
        if (!valido) throw new Error("validacao com erro");

        if (this.solicitacao.itens.length > 0) return true;

        $('#tabs a[href="#tab-dados-fatura"]').tab('show');

        this.$swal(
          '',
          'A solicitação deve possuir ao menos um item.',
          'info'
        );

        throw new Error("validacao");
      },
      enviar(valido) {
        if (!valido) throw new Error("validacao com erro");
        
        const copiaSolicitacao = JSON.parse(JSON.stringify(this.solicitacao));
        
        copiaSolicitacao.arquivosDeletados = this.$refs.listaArquivos.deletados;
        const arquivos = this.$refs.adicionarArquivos.arquivos;

        if (this.$route.params.id) {
          return solicitacaoFaturamentoServico.alterar(copiaSolicitacao, arquivos, this.$route.params.id);
        } else {
          return solicitacaoFaturamentoServico.adicionar(copiaSolicitacao, arquivos);
        }
      },
      camposSolicitacao() {
        return {
          idCoordenador: '',
          tipoSolicitacao: 3,
          idProjeto: '', 
          descricao: '', 
          justificativajustificativa: '', 
          nome: '', 
          documento: '', 
          inscricaoEstadual: '', 
          enderecoFaturamento: '', 
          numeroFaturamento: '', 
          complementoFaturamento: '', 
          cidadeFaturamento: '', 
          ufFaturamento: '', 
          bairroFaturamento: '',
          cepFaturamento: '', 
          telefoneFaturamento: '', 
          faxFaturamento: '', 
          contatoFaturamento: '', 
          obsFaturamento: '', 
          enderecoCobranca: '', 
          numeroCobranca: '', 
          complementoCobranca: '', 
          cidadeCobranca: '', 
          ufCobranca: '', 
          bairroCobranca: '', 
          cepCobranca: '', 
          comDocumentoTecnico: 'false', 
          documentoTecnico: '',
          pedidoCompraProcesso: '',
          formaPagamento: 1, 
          destinoNotaFiscal: '', 
          idRubrica: '', 
          idSubRubrica: '', 
          idConta: '', 
          valor: '', 
          agencia: '', 
          banco: '', 
          contaCorrente: '', 
          tipoConta: '', 
          tipoValor: '', 
          dataPagamento: '', 
          idCodItemServico: '', 
          idUnidade: '', 
          idDepartamento: '', 
          contato: '', 
          inscricaoMunicipal: '',
          pais: '',
          paisCobranca: '',
          idMoeda: '',
          projeto: {
            idProjeto: '',
            nomeProjeto: '',
          },
          itens: [],
        };
      },
      carregar(id) {
        this.carregando = true;

        let solicitacao = null;

        solicitacaoFaturamentoServico
          .obterPorId(id)
          .then(dados => {
            solicitacao = dados;
          })
          .then(() => {
            solicitacao.dataPagamento = this.$options.filters.formatarNumeroEmData(solicitacao.dataPagamento);
            if (solicitacao.comDocumentoTecnico)
              solicitacao.comDocumentoTecnico = solicitacao.comDocumentoTecnico.toString();
            solicitacao.valor = this.$options.filters.formatarNumero(solicitacao.valor);
            
            if (this.configuracao.abreviaturaFundacao.toUpperCase() === 'FUSP') {
              solicitacao.itens.map(item => {
                item.quantidade = this.$options.filters.formatarNumero(item.quantidade); 
                item.valor = this.$options.filters.formatarNumero(item.valor); 
              });
            } 
          })
          .then(() => solicitacaoFaturamentoServico.arquivos(id))
          .then(arquivos => {
            this.arquivos = arquivos;
          })
          .then(() => {
            this.$set(this, 'solicitacao', solicitacao);
            this.buscaDesabilitarBeneficiario();
            this.carregando = false;
          });
      },
      download(arquivo) {
        solicitacaoFaturamentoServico
          .download(this.$route.params.id, arquivo)
          .then(arquivo => {
            arquivo.download();
          });
      },
      resetarComponente() {
        Object.assign(this.$data, this.$options.data.apply(this));
      },
    },
    created() {
      if (this.$route.params.id) {
        this.$set(this, 'mostrarFormulario', true);
        this.carregar(this.$route.params.id);
      }
    },
    watch: {

    }
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <form @submit.prevent="validarBeneficiario">

      <div class="row" v-if="mostrarFormulario">
        <div class="col-xs-12">
          <div class="ibox float-e-margins" v-if="carregando">
            <div class="ibox-content">
              <p class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>
            </div>
          </div>

          <div class="tabs-container" v-show="!carregando" id="tabs">

            <ul class="nav nav-tabs">
              <li class="active">
                <a data-toggle="tab"
                   href="#tab-dados-faturamento">
                  Dados para faturamento
                </a>
              </li>
              <li>
                <a data-toggle="tab"
                   href="#tab-dados-cobranca">
                  Dados para cobrança
                </a>
              </li>
              <li>
                <a data-toggle="tab"
                   href="#tab-dados-fatura">
                  Dados para fatura
                </a>
              </li>
              <li v-if="configuracao.usarArquivosSolicitacaoFaturamento">
                <a data-toggle="tab"
                   href="#tab-adicionar-arquivos">
                  Adicionar arquivos
                </a>
              </li>
              <li v-if="$route.params.id && configuracao.usarArquivosSolicitacaoFaturamento">
                <a data-toggle="tab"
                   href="#tab-lista-arquivos">
                  Arquivos
                </a>
              </li>
            </ul>
            <div class="tab-content">

              <div id="tab-dados-faturamento" class="tab-pane active">
                <div class="panel-body">
                  <dados-faturamento ref="dadosFaturamento"
                                     :solicitacao="solicitacao"
                                     :desabilitarBeneficiario="this.desabilitarBeneficiario"
                                     :edicao="!!$route.params.id">
                  </dados-faturamento>
                </div>
              </div>

              <div id="tab-dados-cobranca" class="tab-pane">
                <div class="panel-body">
                  <dados-cobranca ref="dadosCobranca"
                                  :solicitacao="solicitacao"
                                  :edicao="!!$route.params.id">
                  </dados-cobranca>
                </div>
              </div>

              <div id="tab-dados-fatura" class="tab-pane">
                <div class="panel-body">
                  <dados-fatura ref="dadosFatura"
                                :solicitacao="solicitacao"
                                :edicao="!!$route.params.id">
                  </dados-fatura>
                </div>
              </div>

              <div id="tab-adicionar-arquivos" class="tab-pane">
                <div class="panel-body">
                  <adicionar-arquivos ref="adicionarArquivos">
                  </adicionar-arquivos>
                </div>
              </div>

              <div id="tab-lista-arquivos" class="tab-pane">
                <div class="panel-body">
                  <lista-de-arquivos :arquivos="arquivos"
                                     @download="download"
                                     ref="listaArquivos">
                  </lista-de-arquivos>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>

      <div class="row" v-if="!mostrarFormulario">
        <div class="col-sm-12">
          <div class="form-group required" :class="{'has-error': errors.has('documento')}">
            <label class="control-label" for="documento">Email para faturamento</label>

            <input type="text"
                   class="form-control"
                   id="documento"
                   v-model="documento"
                   data-vv-as="e-mail"
                   data-vv-name="documento"
                   maxlength="100"
                   v-caracteres-email
                   v-validate="'required|email'">

            <p class="text-danger" v-show="errors.has('documento')">{{ errors.first('documento') }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <router-link class="btn btn-default"
                         :to="{ name: 'solicitacao-faturamento-estrangeiro-pj' }"
                         v-show="!mostrarFormulario || !!$route.params.id"
                         active-class="">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </router-link>

            <button id="avancar"
                    type="button"
                    class="btn btn-primary"
                    @click="validarBeneficiario"
                    v-show="!mostrarFormulario"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Carregando...">
              Avançar
              <i class="fa fa-arrow-right"></i>
            </button>

            <button type="button"
                    class="btn btn-default"
                    @click="mostrarFormulario = false, resetarComponente()"
                    v-show="mostrarFormulario && !(!!$route.params.id)">
              <i class="fa fa-arrow-left"></i>
              Volta
            </button>

            <button id="salvar"
                    type="button"
                    class="btn btn-primary"
                    @click="salvar"
                    v-show="mostrarFormulario"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
              <i class="fa fa-save"></i>
              Salvar
            </button>
          </div>
        </div>
      </div>

    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-faturamento-estrangeiro-pj/componentes/SolicitacaoFaturamentoForm.vue